import { useMemo } from "react";
import { useScrollFrameSequence } from "./useScrollFrameSequence";

interface UseFrameSequenceOptions {
  slug: string;
  frameCount: number;
  canvasRef: React.RefObject<HTMLCanvasElement | null>;
  containerRef: React.RefObject<HTMLDivElement | null>;
}

/**
 * Thin compat wrapper around {@link useScrollFrameSequence} for the default
 * legacy join page, which stores frames on R2 at
 * `/cdn/join-frames/{slug}/{i}.jpg`.
 *
 * New premium layouts should call `useScrollFrameSequence` directly with an
 * explicit source.
 */
export function useFrameSequence({
  slug,
  frameCount,
  canvasRef,
  containerRef,
}: UseFrameSequenceOptions) {
  const urls = useMemo(
    () => Array.from({ length: frameCount }, (_, i) => `/cdn/join-frames/${slug}/${i}.jpg`),
    [slug, frameCount],
  );

  useScrollFrameSequence({
    containerRef,
    canvasRef,
    source: { kind: "frames", urls },
  });
}
